import React from 'react'
import styles from './AddMoney.module.scss'
import asideModalStore from 'Stores/asideModalStore'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import { observer } from 'mobx-react'
import SelectCustom from '../../../Select/SelectCustom'

const AddMoney = ({ remove, sum }) => {
  const {
    modalValues: modalValue,
    changeValue: changeValues,
    check,
  } = asideModalStore

  return (
    <div className={styles.groupForm}>
      <FormField>
        <FormLabel isRequired>Количество:</FormLabel>
        <FormInput isError={check('sum') || modalValue?.sum > sum}>
          <input
            type='number'
            placeholder={'Введите число'}
            value={modalValue.sum || ''}
            onChange={(e) => changeValues(e.target.value, 'sum')}
            max={remove ? '' + sum : undefined}
          />
        </FormInput>
      </FormField>
      {modalValue?.sum > sum && (
        <div>
          Нельзя списать больше, чем текущий баланс. Текущий баланс:{' '}
          <strong>{sum}</strong>
        </div>
      )}
      {remove ? (
        <FormField>
          <FormLabel>Комментарий:</FormLabel>
          <FormInput>
            <textarea
              onChange={(e) => changeValues(e.target.value, 'comment')}
              value={modalValue.comment}
              placeholder={'Введите комментарий'}
            />
          </FormInput>
        </FormField>
      ) : (
        <FormField>
          <FormLabel isRequired>{'Выбрать действие'}:</FormLabel>
          <SelectCustom
            placeholder={'Действия'}
            apiLink={'db/coin_activities'}
            valueID={modalValue.comment}
            optionLabelKey='name'
            optionValueKey='name'
            onChange={(level) => changeValues(level.name, 'comment')}
            isSearchable
            error={check('comment')}
          />
        </FormField>
      )}
    </div>
  )
}

export default observer(AddMoney)
